export const TIME_CONSTANTS = {
  MILLISECONDS_PER_MINUTE: 60000,
  MILLISECONDS_PER_HOUR: 3600000,
  MILLISECONDS_PER_DAY: 86400000,
  MILLISECONDS_AT_2359: 86340000,
  HOURS_PER_DAY: 24,
  MINUTES_PER_HOUR: 60,
  MIDNIGHT_24H: '24:00',
  MIDNIGHT_00H: '00:00'
} as const

export const TIME_FORMATS = {
  HOUR_MINUTE: /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])$/,
  TWENTY_FOUR_HOUR: /^24:00$/
} as const